import React, { FC } from "react";
import { Layout1 } from ".";

export const Layout: FC<{ title?: string }> = ({ title, children }) =>
(<Layout1 orderProvider="Mobi2Go" pageTitle={title || "home"} >
    {children}
</Layout1>)

